
import React from 'react';
import { Procurement } from '@/types/database.types';
import { format } from 'date-fns';

interface ProductInfoSectionProps {
  procurement: Procurement;
}

export function ProductInfoSection({ procurement }: ProductInfoSectionProps) {
  const getTotalQuantity = () => {
    if (procurement.items && procurement.items.length > 0) {
      return procurement.items.reduce((total, item) => total + item.quantity, 0);
    }
    return procurement.total_quantity || 0;
  };

  const getProductsCount = () => {
    if (procurement.items && procurement.items.length > 0) {
      return procurement.items.length;
    }
    return procurement.item_count || 1;
  };

  const getProductsSummary = () => {
    if (procurement.items && procurement.items.length > 0) {
      if (procurement.items.length === 1) {
        return procurement.items[0].product_name;
      }
      return `${procurement.items.length} products`;
    }
    
    // Fallback to single product name if items not loaded
    return procurement.product_name || 'N/A';
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Product Information</h3>
      
      <div className="grid gap-3">
        <div className="flex flex-col">
          <span className="text-sm text-muted-foreground">Products</span>
          <span className="font-medium">{getProductsSummary()}</span>
        </div>
        
        <div className="flex flex-col">
          <span className="text-sm text-muted-foreground">Total Quantity</span>
          <span className="font-medium">{getTotalQuantity().toFixed(2)} kg</span>
        </div>
        
        <div className="flex flex-col">
          <span className="text-sm text-muted-foreground">Product Count</span>
          <span className="font-medium">{getProductsCount()} {getProductsCount() === 1 ? 'product' : 'products'}</span>
        </div>
        
        {procurement.quality_grade && (
          <div className="flex flex-col">
            <span className="text-sm text-muted-foreground">Quality Grade</span>
            <span className="font-medium">{procurement.quality_grade}</span>
          </div>
        )}
        
        {procurement.expected_delivery_date && (
          <div className="flex flex-col">
            <span className="text-sm text-muted-foreground">Expected Delivery</span>
            <span className="font-medium">
              {format(new Date(procurement.expected_delivery_date), 'MMM d, yyyy')}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
